
export default function CreateButtonDirective() {
    'ngInject';
    return {
        template: require('./create-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            disabled: '='
        }
    };
}
